import { SliderService } from '@/services/slider.service'

const state = {
    dialog: false,
    loading: true,
    show: false,
    type: null,
    message: null,
    dialogutama: false,
    colordialog: 'indigo',
    judul: '',
    color: '',
    list: []
};


const actions = {
    OpenDialogForm({ commit }) {
        commit('opendialog');
    },
    closeDialog({ commit }) {
        commit('closedialog');
    },
    list({ commit }) {
        commit('setloading');
        SliderService.list().then(data => {
            //console.log(data.data[0]);
            commit('addResponseApp', data);
        }, error => {
            console.log(error);
        });
    },
    Delete({ dispatch, commit }, delete_id) {
        SliderService.hapus(delete_id).then(data => {
            dispatch('alert/success', 'Delete data Successfully', { root: true });
            commit('ShowAdd', data);
            SliderService.list().then(data => {
                commit('addResponseApp', data);
            }, error => {
                console.log(error);
            });
        }, error => {
            dispatch('alert/error', error, { root: true });
        })
    },
    Add({ dispatch, commit }, newData) {
      commit('setloading', true);
      if(!newData.name || !newData.image){
        let msg
        if(!newData.name) msg = "Nama banner tidak boleh kosong"
        else msg = "Gambar banner tidak boleh kosong"
        dispatch('alert/error', msg, { root: true });
        commit('setloading', false);
      } else {
        SliderService.add(newData)
              .then(data => {
                  dispatch('alert/success', data.msg, { root: true });
                  commit('ShowAdd', data);
                  SliderService.list().then(data => {
                      commit('addResponseApp', data);
                  }, error => {
                      console.log(error);
                      dispatch('alert/error', error, { root: true });
                      commit('setloading', false);
                  });
              }, error => {
                  dispatch('alert/error', error, { root: true });
              })
        }
    },
    Edit({ dispatch, commit }, editdata) {
        SliderService.edit(editdata)
            .then(data => {
                dispatch('alert/success', 'Edit data Successfully', { root: true });
                commit('ShowAdd', data);
            }, error => {
                dispatch('alert/error', error, { root: true });
            })
    }
}


const mutations = {
    setloading(state) {
        state.loading = true
    },
    ShowAdd(state, data) {
        console.log(data);
        state.dialog = false;
    },
    addResponseApp(state, apps) {
        state.list = []
        state.list = apps.data.content;
        state.loading = false;
        state.dialog = false;
    },
    opendialog(state) {
        state.dialog = true
    },
    closedialog(state) {
        state.dialog = false
    }
}


export const Slider = {
    namespaced: true,
    state,
    actions,
    mutations
};
